/**
 * Object to holds constants for the site to prevent the use of magic strings.
 */
var constants = {
  pageMode: {
    add: 'add',
    edit: 'edit'
  },
  uploadStatuses: {
    authorising: 'Authorising',
    pending: 'Pending',
    uploading: 'Uploading',
    uploaded: 'Uploaded',
    cancelled: 'Cancelled',
    failed: 'Failed',
    failedAuthorisation: 'FailedAuthorisation'
  },
  requestStatuses: {
    rejected: {
      value: 4
    }
  },
  uploadTypes: {
    file: 'file',
    folder: 'folder'
  },
  requestAssigneeTypes: {
    user: 0,
    group: 1
  },
  tabNames: {
    locationTab: 'Location',
    usersTab: 'Users'
  }
};

export default constants;
